module.exports = __webpack_public_path__ + "static/media/animated-loading.df9d63f9.gif";